import React from "react"
import { MailIcon, PhoneIcon } from "../../assets/svg"
import { IconLink, StyledButton } from "../../elements"

const ContactInfo = (): JSX.Element => {
  return (
    <>
      <IconLink icon={<PhoneIcon />} link="tel:+27861520520" />
      <IconLink icon={<MailIcon />} link="mailto:info@workerslife.co.za" />
    </>
  )
}

export default ContactInfo
